class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {

      if (!event.target.checked && event.target.tagName !== 'SELECT' && event.target.type !== 'range') {
        FacetFiltersForm.toggleActiveFacets();
        const url =  event.target.getAttribute('data-remove-path').indexOf('?') == -1
              ? ''
              : event.target.getAttribute('data-remove-path').slice(event.target.getAttribute('data-remove-path').indexOf('?') + 1);

        FacetFiltersForm.renderPage(url);
      } else {
        this.onSubmitHandler(event);
      }
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (document.querySelector('.js-load-more-btn')) {
      document.querySelector('.js-load-more-btn').setAttribute('data-page', 1);
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const newProductGridContainer = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('ProductGridContainer');

    if (newProductGridContainer) {
      document.getElementById('ProductGridContainer').innerHTML = newProductGridContainer.innerHTML;
    } else {
      document.getElementById('product-grid').innerHTML = '';
      document.querySelector('.collection__load-more').innerHTML = '';
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });


    window.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    try {
      Promise.all(['Yotpo', 'yotpo'].map((propertyName) => (propertyName)));
      const { Yotpo, yotpo } = window;
      const yotpoApi = new Yotpo.API(yotpo);
      yotpoApi.refreshWidgets();
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.error(err);
    }
  }

  static renderProductCount(html) {
    const countSelector = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    let count = window.filtersStings.noResults;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (countSelector) {
      count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;

      window.dispatchEvent(new CustomEvent('search:render', {
        detail: {
          count
        }
      }));
    }

    container.innerHTML = count;
    container.classList.remove('loading');

    // if (containerDesktop) {
    //   containerDesktop.innerHTML = count;
    // }

    containerDesktop.classList.remove('loading');

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    if (facetDetailsElementsFromFetch.length <= 1 ) {
      countContainerDesktop.innerHTML = '0 products';
      return;
    }

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName && document.getElementById(previousElementId)) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.id} .js-filter`)) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const defaultMinPrice = parseInt(document.querySelector('.js-price-range-from-range').min, 10);
    const defaultMaxPrice = parseInt(document.querySelector('.js-price-range-to-range').max, 10);
    const formData = new FormData(form);
    const urlParams = new URLSearchParams(formData);

    const priceMin = urlParams.get('filter.v.price.gte');
    const priceMax = urlParams.get('filter.v.price.lte');

    if (priceMin && parseInt(priceMin, 10) === defaultMinPrice) {
      urlParams.delete('filter.v.price.gte');
    }
    if (priceMax && parseInt(priceMax, 10) === defaultMaxPrice) {
      urlParams.delete('filter.v.price.lte');
    }

    return urlParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event, filterRemoved) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
    if (filterRemoved) window.dispatchEvent(new CustomEvent('search:filterRemove'));
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event, true);
  }
}

customElements.define('facet-remove', FacetRemove);

class FiltersToggle extends HTMLElement {
  constructor() {
    super();

    this.currentlyDesktop = this.isDesktop();
    this.toggles = document.querySelectorAll('filters-toggle');
    this.filters = document.querySelector('#main-collection-filters');

    this.addEventListener('click', this.toggleFilter.bind(this));

    window.addEventListener('resize', () => this.showFilterDesktop());
  }

  isDesktop() {
    return document.documentElement.clientWidth >= 1280;
  }

  toggleFilter(event) {
    event?.preventDefault();

    return this.isDesktop() ? this.toggleFilterDesktop() : this.toggleFilterMobile();
  }

  toggleFilterMobile() {
    this.toggles.forEach((toggle) => (
      toggle.classList.toggle('is-active-mobile')
    ));
    this.filters.classList.toggle('is-active-mobile');
  }

  toggleFilterDesktop() {
    this.toggles.forEach((toggle) => (
      toggle.classList.toggle('is-active')
    ));
    this.filters.classList.toggle('is-active');
  }

  showFilterDesktop() {
    const isDesktop = this.isDesktop();

    if (!this.currentlyDesktop && isDesktop) {
      this.toggles.forEach((toggle) => {
        toggle.classList.add('is-active');
        toggle.classList.remove('is-active-mobile');
      });
      this.filters.classList.add('is-active');
      this.filters.classList.remove('is-active-mobile');
    } else if (this.currentlyDesktop && !isDesktop) {
      this.toggles.forEach((toggle) => {
        toggle.classList.remove('is-active');
      });
      this.filters.classList.remove('is-active');
    }

    this.currentlyDesktop = isDesktop;
  }
}

customElements.define('filters-toggle', FiltersToggle);
